<script>
  import Button from '@components/buttons/button.svelte'
  import Text from '@components/general/text.svelte'
  import { Ticket, Check, Calendar, Zap } from 'lucide-svelte'
  import { format } from 'date-fns'
  import { cn, formatMoney } from '@lib/utils'

  let { offer, selected = false, onSelect } = $props()

  let buttonClasses = $derived(cn(
    'flex flex-col gap-4 w-full max-w-xl rounded-lg border-2 p-6 text-left transition-all',
    'hover:border-primary-400 hover:shadow-sm',
    selected
      ? 'border-primary-500 bg-primary-50/50 ring-1 ring-primary-500/30'
      : 'border-gray-200 bg-white'
  ))

  let iconClasses = $derived(cn('flex h-9 w-9 shrink-0 items-center justify-center rounded-full', selected ? 'bg-primary-100' : 'bg-gray-100'))

  let iconTextClasses = $derived(cn('text-primary-600', selected ? 'text-primary-600' : 'text-gray-400'))

  let checkClasses = $derived(cn('text-primary-600 shrink-0'))

  
</script>

<!-- Selectable offer card -->
<Button variant="naked" onclick={onSelect} class={buttonClasses}>

  <!-- Icon and selected check -->
  <div class="flex items-start justify-between gap-2">
    <div class="flex flex-col items-center gap-2">
      <div class={iconClasses}>
        <Ticket size={18} class={iconTextClasses} />
      </div>

      <span class="inline-flex items-center gap-1 rounded-full bg-green-50 px-2.5 py-1 text-xs font-medium text-green-700 border border-green-200">
        <Zap size={12} />
        Start today
      </span>
    </div>

    {#if selected}
      <Check size={18} class={checkClasses} />
    {/if}
  </div>

  <!-- Name and price -->
  <div class="flex flex-col items-center gap-1 text-center">
    <Text as="span" class="font-serif text-lg text-gray-800">{offer.name}</Text>
    <Text as="span" class="text-2xl font-serif text-gray-800">
      {formatMoney(offer.amount_cents)}
      <small class="text-gray-500">+ VAT</small>
    </Text>
    <Text variant="label" as="span" class="text-gray-500">Immediate full access after secure checkout.</Text>
  </div>

  <!-- Dates -->
  <div class="flex flex-col gap-1 mt-auto">
    {#if offer.entitlement_end_date}
      <Text variant="label" as="span" class="flex items-center gap-1.5 text-gray-500">
        <Calendar size={12} />
        Access until {format(new Date(offer.entitlement_end_date), 'd MMM yyyy')}
      </Text>
    {/if}

    {#if offer.closes_on}
      <Text variant="label" as="span" class="text-amber-600">
        Offer closes {format(new Date(offer.closes_on), 'd MMM yyyy')}
      </Text>
    {/if}
  </div>

</Button>
